export class Country {
  public static isCountry(countryToCheck: string, country: string): boolean {
    if (Boolean(country) && Boolean(countryToCheck)) {
      return this.isOneOfCountries([countryToCheck], country);
    }
    return false;
  }

  public static isOneOfCountries(
    inCountries: Array<string>,
    country: string
  ): boolean {
    if (Boolean(country) && Boolean(inCountries)) {
      return inCountries.some((countryToCheck: string) => {
        return countryToCheck.toUpperCase() === country.toUpperCase();
      });
    }
    return false;
  }

  public static isFrenchFiscal(country: string): boolean {
    return Country.isOneOfCountries(
      ['France', 'Monaco', 'Guadeloupe', 'Martinique', 'Reunion'],
      country
    );
  }
}
